import { jsx as r } from "react/jsx-runtime";
import { w as a } from "../../../vendor-Dd6qj6gJ.js";
import { Surface as c } from "../../Surface/index.js";
import { Menu as n } from "../Menu/index.js";
import { layer as i } from "../../../theme/layer.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as u } from "../../../utils/omitStyleRenderProps/index.js";
import '../../../assets/index31.css';const l = "_popover_1ur69_1", _ = "_surface_1ur69_28", o = {
  popover: l,
  surface: _
};
function S({
  isOpen: e,
  onOpenChange: t,
  triggerRef: p,
  placement: m,
  children: s,
  ...f
}) {
  return /* @__PURE__ */ r(
    a,
    {
      isOpen: e,
      onOpenChange: t,
      triggerRef: p,
      className: o.popover,
      style: { zIndex: i("menu") },
      offset: 0,
      placement: m,
      children: /* @__PURE__ */ r(c, { className: o.surface, children: /* @__PURE__ */ r(n, { ...u(f), children: s }) })
    }
  );
}
export {
  S as Content
};
